export function isStaffHasPermission(roles, types, actions) {
  if (isAdmin(roles)) return true;
  if (isManager(roles)) return true;
  if (isEditor(roles) && (!actions || actions.includes('edit'))) return true;
  // types.includes('project','product','profile','about','info','cloud','category') &&

  // 2022/3/9 Chen don't want role edit page any more, let's comment it and use above code,
  // don't remove this avoid one day Chen changed her mind.
  // if (isStaff(roles)) {
  // const i = types.indexOf('information');
  // if(i>-1) types[i]='info';
  // if (actions !==undefined)
  //   return !!roles.find(r => r.permissions.find(p =>    types.includes(p.type) && actions.includes(p.action)));
  // return !!roles.find(r => r.permissions.find(p => types.includes(p.type)));
  // }
  return false;
}

export function isStaff(roles) {
  return isRole(roles, ['admin', 'manager', 'editor', 'seller']);
}

export function isPartner(roles) {
  return isRole(roles, ['partner']);
}

export function isJudge(roles) {
  return isRole(roles, ['judge']);
}

export function isAdmin(roles) {
  return isRole(roles, ['admin']);
}

export function isManager(roles) {
  return isRole(roles, ['manager']);
}

export function isEditor(roles) {
  return isRole(roles, ['editor']);
}

export function isSeller(roles) {
  return isRole(roles, ['seller']);
}

export function isReader(roles) {
  return isRole(roles, ['reader']);
}

export function isMangerAndPartner(roles) {
  return isRole(roles, ['admin', 'manager', 'partner']);
}

function isRole(roles, roleTiles) {
  if (!roles || roles.length < 1) return false;
  return !!roles.find((role) => roleTiles.includes(role.title));
}

export function isNotRole(roles, roleTiles) {
  if (!roles || roles.length < 1) {
    return false;
  }
  return !!roles.find((role) => role.title && !roleTiles.includes(role.title));
}
